import React from 'react'
import TemplateLink from 'components/navigation/TemplateLink'

export const commaSeparatedList = (strings: string[]) => {
  if (!strings) return undefined
  if (strings.length === 1) return strings[0]
  const list = strings.slice(0, -1).join(', ')
  const last = strings[strings.length - 1]
  const oxfordComma = strings.length > 2 ? ',' : ''
  return `${list}${oxfordComma} and ${last}`
}

export const displayOwner = (owner: string | string[]) => {
  // check to see if array
  if (Array.isArray(owner)) {
    return owner.join('; ')
  }
  // otherwise return raw string
  return owner
}

export const truncateDescription = (
  resource: any,
  description: string,
  word_count: number
) => {
  if (word_count < 3) {
    throw new Error(
      'Please provide a word_count of 3 or greater to ' +
        'the truncateDescription function. Provided word_count was: ' +
        word_count +
        '.'
    )
  }
  return description.split(' ').length > word_count ? (
    <>
      {description
        .split(' ')
        .slice(0, word_count - 1)
        .join(' ')}
      ...{' '}
      <TemplateLink data={resource} openInNewTab>
        <em>read more</em>
      </TemplateLink>
    </>
  ) : (
    <>{description}</>
  )
}

export const capitalize = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1)
